var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfilechange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 178,
    height: 178,
    viewBox: "0 0 178 178",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M174 134.769V160.923C174 164.391 172.622 167.717 170.17 170.17C167.717 172.622 164.391 174 160.923 174H134.769M134.769 4H160.923C164.391 4 167.717 5.37774 170.17 7.83014C172.622 10.2825 174 13.6087 174 17.0769V43.2308M4 43.2308V17.0769C4 13.6087 5.37774 10.2825 7.83014 7.83014C10.2825 5.37774 13.6087 4 17.0769 4H43.2308M43.2308 174H17.0769C13.6087 174 10.2825 172.622 7.83014 170.17C5.37774 167.717 4 164.391 4 160.923V134.769M89 82.4615C95.9364 82.4615 102.589 79.7061 107.494 74.8013C112.398 69.8965 115.154 63.2441 115.154 56.3077C115.154 49.3713 112.398 42.7189 107.494 37.8141C102.589 32.9093 95.9364 30.1538 89 30.1538C82.0636 30.1538 75.4112 32.9093 70.5064 37.8141C65.6016 42.7189 62.8462 49.3713 62.8462 56.3077C62.8462 63.2441 65.6016 69.8965 70.5064 74.8013C75.4112 79.7061 82.0636 82.4615 89 82.4615ZM138.732 141.308C135.352 130.774 128.714 121.586 119.777 115.068C110.839 108.549 100.062 105.037 89 105.037C77.9377 105.037 67.1611 108.549 58.2234 115.068C49.2856 121.586 42.6485 130.774 39.2685 141.308H138.732Z",
    stroke: "white",
    strokeWidth: 7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfilechange);
export default __webpack_public_path__ + "static/media/profile change.3bace7ea5d9f883cbcb7320a7f60abb5.svg";
export { ForwardRef as ReactComponent };